import { COMMA, ENTER } from "@angular/cdk/keycodes";
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { ApiVisa, BudgetRegisterService, Pagination } from "blg-akaun-ts-lib";
import { AppConfig } from "../../visa";
import { SubSink } from "subsink2";

@Component({
  selector: "app-select-budget-register-gen-doc",
  templateUrl: "./select-budget-register-gen-doc.component.html",
  styleUrls: ["./select-budget-register-gen-doc.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectBudgetRegisterGenDocComponent
  implements OnDestroy, OnChanges
{
  @Input() budgetRegister = new FormControl();
  @Input() budgetVotebookGuid: string;
  @Input() budgetFiscalYearGuid: string;
  @Input() budgetFiscalPeriodGuid: string;
  @Input() budgetItemGuid: string;
  @Output() selectionChange = new EventEmitter();

  private subs = new SubSink();
  separatorKeysCodes: number[] = [ENTER, COMMA];
  apiVisa: ApiVisa = AppConfig.apiVisa;

  allBudgetRegisters: any;
  searchBudgetRegisters: any = [];

  constructor(private budgetRegisterService: BudgetRegisterService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      "budgetVotebookGuid" in changes ||
      // "budgetFiscalYearGuid" in changes ||
      "budgetFiscalPeriodGuid" in changes ||
      "budgetItemGuid" in changes
    ) {
      // React to changes in budgetVotebookGuid, budgetFiscalPeriodGuid, or budgetItemGuid here
      let newBudgetVotebookGuid = this.budgetVotebookGuid;
      // let newBudgetFiscalYearGuid = this.budgetFiscalYearGuid;
      let newBudgetFiscalPeriodGuid = this.budgetFiscalPeriodGuid;
      let newBudgetItemGuid = this.budgetItemGuid;

      // Perform operations based on the new values
      if (
        newBudgetVotebookGuid !== null ||
        // newBudgetFiscalYearGuid !== null ||
        newBudgetFiscalPeriodGuid !== null ||
        newBudgetItemGuid !== null
      ) {
        // Fetch budget registers based on the provided criteria
        this.subs.sink = this.budgetRegisterService
          .getByCriteria(
            new Pagination(0, 10000, [
              {
                columnName: "votebook_guid",
                operator: "=",
                value: newBudgetVotebookGuid,
              },
              // {
              //   columnName: "budget_fiscal_year_guid",
              //   operator: "=",
              //   value: newBudgetFiscalYearGuid,
              // },
              {
                columnName: "budget_fiscal_period_guid",
                operator: "=",
                value: newBudgetFiscalPeriodGuid,
              },
              {
                columnName: "budget_item_guids",
                operator: "=",
                value: [newBudgetItemGuid].toString(),
              },
            ]),
            this.apiVisa
          )
          .subscribe((compResponse) => {
            const budgetRegisterListing = compResponse.data.map(
              (data, index) => ({
                name: data.bl_fi_budget_register.name,
                code: data.bl_fi_budget_register.code,
                guid: data.bl_fi_budget_register.guid,
              })
            );
            this.allBudgetRegisters = budgetRegisterListing;
            this.searchBudgetRegisters = budgetRegisterListing;
          });
      }
    }
  }

  applyBudgetRegisterFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.searchBudgetRegisters = this.allBudgetRegisters.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
